import React from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { URLS } from '@wix/da-url';
import Button from '../../../Button';
import s from './EmptyState.scss';
export var EmptyState = function (_a) {
    var className = _a.className;
    var t = useTranslation().t;
    return (React.createElement("div", { className: classnames(s['root'], className) },
        React.createElement("div", { className: s['title-wrapper'] },
            React.createElement("div", { className: s['title'] }, t('addToGroup.emptyState.title')),
            React.createElement("div", { className: s['subtitle'] }, t('addToGroup.emptyState.subtitle')),
            React.createElement(Button, { view: "b16-undisciplined-designers", className: s['button'], href: URLS.GROUPS }, t('addToGroup.emptyState.buttonLabel')))));
};
EmptyState.displayName = 'EmptyState';
export default EmptyState;
//# sourceMappingURL=EmptyState.js.map